const getRpc = (rpcUrl) => {
  return import.meta.env.VITE_APP_SOLANA_ENV === 'devnet'
    ? import.meta.env.VITE_SOLANA_RPC
    : rpcUrl;
};

export const RPC_MAPS = {
  // Rpc2: getRpc('https://solana-public.agents.land'), // agents.land
  Rpc1: getRpc('https://dedicated-rpc.agents.land'),
  Rpc2: getRpc(
    'https://rpc.ironforge.network/mainnet?apiKey=01J3QVEMHPE2ZSG1BAGGJ9G60W',
  ), // moongate
  Rpc3: getRpc(
    'https://rpc.ironforge.network/mainnet?apiKey=01HYNQ388BQNCFHTKG8WHRMMWC',
  ), // tiplink

  Custom: 'https://',
};

export const RPC_ORAI_EVM_CONFIG = {
  devnet: {
    RPC_ORAI_EVM: 'https://testnet-v2.evm.orai.io',
    ORAI_EVM_CHAIN_ID: '0xf6f73cb0', // 4143398064
    ORAI_EVM_CHAIN_ID_NUMBER: 4143398064,
    ORAI_EVM_CHAIN_ID_NEW_FORMAT: 'eip155:4143398064',
    NAME: 'Oraichain EVM Testnet',
    LAUNCHPAD_ADDRESS: '0xbfD91A9E3346C69A7c02972287c180356735ba23',
    FACTORY_ADDRESS: '0x8e9512dDF747312139448B6E01eb84341D69BA25',
  },
  'mainnet-beta': {
    RPC_ORAI_EVM: 'https://evm.orai.io',
    ORAI_EVM_CHAIN_ID: '0x67266a7', // 108160679
    ORAI_EVM_CHAIN_ID_NUMBER: 108160679,
    ORAI_EVM_CHAIN_ID_NEW_FORMAT: 'eip155:108160679',
    NAME: 'Oraichain Mainnet',
    LAUNCHPAD_ADDRESS: '0x1AfFEB6B9B605ce5967D7b540473f2b4C05aDA14',
    FACTORY_ADDRESS: '0x1feddd331e30922e311FFC9584ec2997787E9B7f', // update later
  },
};

export const CURRENT_ORAI_EVM_CONFIG: {
  RPC_ORAI_EVM: string;
  ORAI_EVM_CHAIN_ID: string;
  ORAI_EVM_CHAIN_ID_NUMBER: number;
  ORAI_EVM_CHAIN_ID_NEW_FORMAT: string;
  NAME: string;
  LAUNCHPAD_ADDRESS: string;
  FACTORY_ADDRESS: string;
} =
  RPC_ORAI_EVM_CONFIG[import.meta.env.VITE_APP_SOLANA_ENV] ||
  RPC_ORAI_EVM_CONFIG['mainnet-beta'];

export const LAUNCHPAD_ADDRESS_ORAI_EVM =
  CURRENT_ORAI_EVM_CONFIG.LAUNCHPAD_ADDRESS;
export const FACTORY_ADDRESS_ORAI_EVM = CURRENT_ORAI_EVM_CONFIG.FACTORY_ADDRESS;
export const NAME_ORAI_EVM = CURRENT_ORAI_EVM_CONFIG.NAME;
export const RPC_ORAI_EVM = CURRENT_ORAI_EVM_CONFIG.RPC_ORAI_EVM;
export const ORAI_EVM_CHAIN_ID = CURRENT_ORAI_EVM_CONFIG.ORAI_EVM_CHAIN_ID;
export const ORAI_EVM_CHAIN_ID_NUMBER =
  CURRENT_ORAI_EVM_CONFIG.ORAI_EVM_CHAIN_ID_NUMBER;
export const ORAI_EVM_CHAIN_ID_NEW_FORMAT =
  CURRENT_ORAI_EVM_CONFIG.ORAI_EVM_CHAIN_ID_NEW_FORMAT;

export const HELIUS_RPC_DEFAULT = getRpc('https://solana-public.agents.land');

export const RPC_DEFAULT_KEY = 'Rpc1';
export const RPC_FALLBACK_KEY = 'Rpc2';
export const DEFAULT_RPC = RPC_MAPS[RPC_DEFAULT_KEY] || RPC_MAPS.Rpc1;
export const FALLBACK_RPC = RPC_MAPS[RPC_FALLBACK_KEY] || RPC_MAPS.Rpc2;
